<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0028 2.66246C6.85847 2.66246 2.67499 6.84484 2.67499 11.9961C2.67499 17.1474 6.85847 21.3299 12.0028 21.3299C17.1571 21.3299 21.3405 17.1474 21.3405 11.9961C21.3405 6.84484 17.1571 2.66246 12.0028 2.66246ZM12.0028 3.9135C16.4665 3.9135 20.0895 7.53532 20.0895 11.9961C20.0895 16.4569 16.4665 20.0789 12.0028 20.0789C7.54905 20.0789 3.92603 16.4569 3.92603 11.9961C3.92603 7.53532 7.54905 3.9135 12.0028 3.9135ZM13.8143 15.2769C14.4948 15.0277 15.0353 14.4862 15.2855 13.7996C15.8159 12.3454 16.9169 9.3069 17.4273 7.8708C17.5674 7.50019 17.4773 7.08544 17.1971 6.80681C16.9169 6.52818 16.5065 6.4358 16.1362 6.56991C14.695 7.08965 11.6525 8.18997 10.2013 8.71641C9.51068 8.96462 8.97023 9.50607 8.73003 10.1926C8.19959 11.6469 7.09867 14.6864 6.57824 16.1216C6.44813 16.4919 6.53821 16.9072 6.81844 17.1855C7.09867 17.4647 7.50902 17.5568 7.87932 17.4227L13.8143 15.2769ZM13.3839 14.0999L7.92937 16.0755L9.90101 10.619C10.0211 10.2807 10.2913 10.0145 10.6316 9.89239L16.0862 7.91724L14.1145 13.3743C13.9844 13.7116 13.7242 13.9778 13.3839 14.0999ZM12.0028 10.61C12.7734 10.61 13.3939 11.2315 13.3939 11.9961C13.3939 12.7618 12.7734 13.3823 12.0028 13.3823C11.2421 13.3823 10.6216 12.7618 10.6216 11.9961C10.6216 11.2315 11.2421 10.61 12.0028 10.61Z"
      fill="#6F8693"
    />
  </svg>
</template>

<script>
export default {
  name: 'CompassVariableColor'
};
</script>

<style scoped>
svg circle {
  fill: currentColor;
}
</style>
